(() => {
  const VERSION = '2026.08.25.1';
  const previous = window.BHMobileBottomNav;
  if (previous?.version === VERSION) {
    previous.refresh?.();
    return;
  }
  previous?.controller?.abort?.();

  const controller = new AbortController();
  const signal = controller.signal;
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const CART_MUTATION_PATTERN = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/i;
  let lastScrollY = Math.max(0, window.scrollY || 0);
  let scrollFrame = 0;
  let cartTimer = 0;
  let cartRequest = 0;
  let navHidden = false;
  let layoutTimers = [];

  function navs() {
    return [...document.querySelectorAll('[data-bh-mobile-nav]')];
  }

  function normalizePath(value) {
    try {
      const url = new URL(value, window.location.origin);
      const path = url.pathname.replace(/\/+$/, '');
      return path || '/';
    } catch (_) {
      return '/';
    }
  }

  function setActiveItem(nav) {
    const currentPath = normalizePath(window.location.href);
    const currentSearch = window.location.search;
    let active = null;

    nav.querySelectorAll('[data-bh-nav-item]').forEach(item => {
      const itemPath = normalizePath(item.href);
      const key = item.dataset.navKey;
      const matches =
        (key === 'home' && currentPath === normalizePath(window.Shopify?.routes?.root || '/')) ||
        (key === 'search' && currentPath.includes('/search')) ||
        (key === 'cart' && currentPath.includes('/cart')) ||
        (key === 'account' && currentPath.includes('/account')) ||
        (key === 'offers' && itemPath === currentPath && !currentSearch.includes('view='));

      item.classList.toggle('is-active', matches);
      if (matches) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
      if (matches) active = item;
    });

  }

  function activateItem(item) {
    const nav = item?.closest('[data-bh-mobile-nav]');
    if (!nav) return;

    nav.querySelectorAll('[data-bh-nav-item]').forEach(candidate => {
      const selected = candidate === item;
      candidate.classList.toggle('is-active', selected);
      if (selected) candidate.setAttribute('aria-current', 'page');
      else candidate.removeAttribute('aria-current');
    });
  }

  function setCartCount(count) {
    const numeric = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-bh-nav-cart-count]').forEach(element => {
      const previousCount = element.dataset.count;
      element.textContent = numeric > 99 ? '99+' : String(numeric);
      element.dataset.count = String(numeric);
      element.classList.toggle('is-empty', numeric === 0);
      if (previousCount !== undefined && previousCount !== String(numeric)) {
        element.classList.remove('is-updated');
        void element.offsetWidth;
        element.classList.add('is-updated');
        window.setTimeout(() => element.classList.remove('is-updated'), 420);
      }
    });
    document.querySelectorAll('[data-bh-nav-cart]').forEach(element => {
      element.setAttribute('aria-label', `Carrito, ${numeric} productos`);
    });
  }

  async function refreshCart() {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const requestId = ++cartRequest;
    try {
      const response = await fetch(`${normalizedRoot}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId !== cartRequest) return;
      setCartCount(cart.item_count);
    } catch (error) {
      console.warn('[BH Mobile Nav] No se pudo actualizar el carrito.', error);
    }
  }

  function scheduleCartRefresh(delay = 70) {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(refreshCart, delay);
  }

  function cartMutationUrl(value) {
    try {
      const raw = value instanceof Request ? value.url : String(value || '');
      const parsed = new URL(raw, window.location.origin);
      return parsed.origin === window.location.origin && CART_MUTATION_PATTERN.test(`${parsed.pathname}${parsed.search}`);
    } catch (_) {
      return false;
    }
  }

  function installCartNetworkBridge() {
    const bridgeKey = '__BH_MOBILE_NAV_CART_BRIDGE__';
    if (window[bridgeKey]) return;
    window[bridgeKey] = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = async function bhCartAwareFetch(...args) {
        const response = await originalFetch.apply(this, args);
        if (response.ok && cartMutationUrl(args[0])) {
          document.dispatchEvent(new CustomEvent('bh:cart:network-complete'));
        }
        return response;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function bhCartAwareOpen(method, requestUrl, ...rest) {
      this.__bhCartMutation = cartMutationUrl(requestUrl);
      return originalOpen.call(this, method, requestUrl, ...rest);
    };
    XMLHttpRequest.prototype.send = function bhCartAwareSend(...args) {
      if (this.__bhCartMutation) {
        this.addEventListener('loadend', () => {
          if (this.status >= 200 && this.status < 400) {
            document.dispatchEvent(new CustomEvent('bh:cart:network-complete'));
          }
        }, { once: true });
      }
      return originalSend.apply(this, args);
    };
  }

  function setNavHidden(hidden) {
    const next = Boolean(hidden && mobileQuery.matches && navs().length > 0);
    if (navHidden === next) return;
    navHidden = next;
    navs().forEach(nav => nav.classList.toggle('is-scroll-hidden', next));
    document.documentElement.classList.toggle('bh-mobile-nav-scroll-hidden', next);
    requestAnimationFrame(syncStickyOffset);
  }

  function updateScrollState() {
    scrollFrame = 0;
    if (!mobileQuery.matches) {
      setNavHidden(false);
      return;
    }

    const current = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
    const delta = current - lastScrollY;
    const closeToTop = current < 72;
    const pageBottom = current + window.innerHeight >= document.documentElement.scrollHeight - 24;
    const purchaseInProgress = Boolean(document.querySelector(
      '.bh-sticky-buy-bar:is(.is-adding, .is-added, .is-buying-now, .has-action-error)'
    ));

    if (purchaseInProgress || closeToTop || pageBottom) setNavHidden(false);
    else if (delta > 7) setNavHidden(true);
    else if (delta < -5) setNavHidden(false);

    lastScrollY = current;
  }

  function onScroll() {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(updateScrollState);
  }

  function isVisibleFixed(element) {
    if (!(element instanceof HTMLElement)) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.position === 'fixed' &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number.parseFloat(style.opacity || '1') > .02 &&
      rect.width > 0 && rect.height > 0;
  }

  function syncStickyOffset() {
    const stickyBars = [...document.querySelectorAll('[data-bh-sticky-buy-bar], .bh-sticky-buy-bar')];
    const visibleBar = stickyBars.find(isVisibleFixed);
    const measuredHeight = visibleBar ? Math.ceil(visibleBar.getBoundingClientRect().height) + 8 : 0;
    const height = Math.min(Math.max(measuredHeight, 0), 112);
    const nextValue = `${height}px`;
    if (document.documentElement.style.getPropertyValue('--bh-sticky-buy-offset') !== nextValue) {
      document.documentElement.style.setProperty('--bh-sticky-buy-offset', nextValue);
    }
  }

  function removeLegacyWhatsappWidget() {
    document.querySelectorAll('#whatsapp-widget-root').forEach(widget => {
      /* El botón directo nuevo usa .bh-whatsapp-direct y nunca debe eliminarse. */
      if (!widget.matches('.bh-whatsapp-direct') && !widget.querySelector('.bh-whatsapp-direct')) {
        widget.remove();
      }
    });

    document.querySelectorAll('#chat-bubble.whatsapp-widget, #chat-bubble.bh-mobile-nav-whatsapp').forEach(widget => {
      const owner = widget.closest('#whatsapp-widget-root') || widget;
      if (!owner.matches('.bh-whatsapp-direct') && !owner.querySelector('.bh-whatsapp-direct')) {
        owner.remove();
      }
    });
  }

  function syncFloatingLayout() {
    syncStickyOffset();
    removeLegacyWhatsappWidget();
  }

  function initialize() {
    const elements = navs();
    document.documentElement.classList.toggle('bh-product-page', /\/products\//.test(window.location.pathname));
    document.documentElement.classList.toggle('bh-mobile-nav-visible', elements.length > 0);
    elements.forEach(setActiveItem);
    scheduleCartRefresh(0);
    syncFloatingLayout();
    layoutTimers.forEach(timer => window.clearTimeout(timer));
    layoutTimers = [250, 800, 1800].map(delay => window.setTimeout(syncFloatingLayout, delay));
    lastScrollY = Math.max(0, window.scrollY || 0);
    setNavHidden(false);
  }

  document.addEventListener('click', event => {
    const item = event.target.closest('[data-bh-nav-item]');
    if (!item) return;

    activateItem(item);
    setNavHidden(false);

    /* Todos los accesos, incluido Carrito, conservan su href nativo. */
  }, { signal });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement && cartMutationUrl(form.action)) scheduleCartRefresh(350);
  }, { signal, capture: true });

  document.addEventListener('bh:cart:network-complete', () => scheduleCartRefresh(60), { signal });

  ['cart:updated', 'cart:refresh', 'theme:cart:update'].forEach(eventName => {
    document.addEventListener(eventName, event => {
      const cart = event.detail?.cart;
      if (typeof cart?.item_count === 'number') setCartCount(cart.item_count);
      else scheduleCartRefresh(0);
    }, { signal });
  });

  document.addEventListener('shopify:section:load', initialize, { signal });
  document.addEventListener('shopify:section:unload', initialize, { signal });
  window.addEventListener('resize', syncFloatingLayout, { signal, passive: true });
  window.addEventListener('scroll', onScroll, { signal, passive: true });
  window.addEventListener('pageshow', () => scheduleCartRefresh(0), { signal });
  window.addEventListener('focus', () => scheduleCartRefresh(0), { signal });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleCartRefresh(0);
  }, { signal });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('[data-bh-mobile-nav], [data-bh-sticky-buy-bar], .bh-sticky-buy-bar')) {
      setNavHidden(false);
    }
  }, { signal, passive: true });
  mobileQuery.addEventListener?.('change', () => {
    lastScrollY = Math.max(0, window.scrollY || 0);
    setNavHidden(false);
  }, { signal });

  const observer = new MutationObserver(() => {
    syncStickyOffset();
    removeLegacyWhatsappWidget();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'src', 'href']
  });
  const observerTimeout = window.setTimeout(() => observer.disconnect(), 8000);
  signal.addEventListener('abort', () => {
    observer.disconnect();
    window.clearTimeout(observerTimeout);
    window.clearTimeout(cartTimer);
    layoutTimers.forEach(timer => window.clearTimeout(timer));
    cancelAnimationFrame(scrollFrame);
  }, { once: true });

  window.BHMobileBottomNav = {
    version: VERSION,
    controller,
    refresh: initialize,
    refreshCart,
    setCartCount,
    syncFloatingLayout
  };

  installCartNetworkBridge();
  initialize();
})();
